import Vue from 'vue'
import VueRouter from 'vue-router'
import { RouterMap } from './config'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes: RouterMap
});

const originalPush = VueRouter.prototype.push;
// console.log(originalPush);
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
